import { RouterHistory, createBrowserHistory, createMemoryHistory } from '@tanstack/react-router';

// The histories are created on first use so this module has no side effects.
let megaModalHistory: RouterHistory | undefined;
let browserHistory: RouterHistory | undefined;

export function getMegaModalHistory(): RouterHistory {
  if (!megaModalHistory) {
    megaModalHistory = createMemoryHistory();
  }
  return megaModalHistory;
}

export function getBrowserHistory(): RouterHistory {
  if (!browserHistory) {
    browserHistory = createBrowserHistory();
  }
  return browserHistory;
}
